export default __webpack_public_path__ + "images/cfb4ba615da8f72d1c841d113ff02e16-generic_2_mobile.webp";